import { ONE_MEBIBYTE, ONE_MINUTE, ONE_SECOND } from '@lucidlink/uicore';
export const DownloadUrlSearchParams = {
    FsEntryId: 'fsEntryId',
    FsEntryName: 'fsEntryName',
    FsEntrySize: 'fsEntrySize',
    IsUnifiedDownload: 'isUnifiedDownload',
};
// One mebibyte is the usual block size. IMPORTANT: If we do not read
// in multiples of the block sizes, we get duplicated requests as we're
// reading very innefficiently the blocks, getting bits and pieces of
// the previous / next block;
// eslint-disable-next-line unicorn/prefer-export-from -- I want a separate constant, not to reexport
export const DEFAULT_FILE_DOWNLOAD_CHUNK_SIZE = ONE_MEBIBYTE;
export const CONCURRENT_DOWNLOAD_FILE_SIZE_THRESHOLD = 5 * ONE_MEBIBYTE;
export const ZERO_BYTES_BIG_INT = 0n;
export const ARCHIVE_EXTENSION = '.zip';
export const DEFAULT_ARCHIVE_BASE_NAME = 'lucid-download';
export const BATCH_ENTRY_QUEUE_CAPACITY = 10_000;
export const NETWORK_RETRY_INITIAL_DELAY = ONE_SECOND / 2;
export const NETWORK_RETRY_MAX_DELAY = 30 * ONE_SECOND;
export const NETWORK_RETRY_ATTEMPTS = 20;
export const NETWORK_RETRY_DEADLINE = 10 * ONE_MINUTE;
export const READ_DIR_PAGE_LIMIT = 2000;
